import { render, staticRenderFns } from "./wl-table-main.vue?vue&type=template&id=74dd5fdc&scoped=true&lang=pug"
import script from "./wl-table-main.js?vue&type=script&lang=js&external"
export * from "./wl-table-main.js?vue&type=script&lang=js&external"
import style0 from "./wl-table-main.styl?vue&type=style&index=0&id=74dd5fdc&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74dd5fdc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\G\\YT\\mes-project-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74dd5fdc')) {
      api.createRecord('74dd5fdc', component.options)
    } else {
      api.reload('74dd5fdc', component.options)
    }
    module.hot.accept("./wl-table-main.vue?vue&type=template&id=74dd5fdc&scoped=true&lang=pug", function () {
      api.rerender('74dd5fdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/wl-component-gallery/wl-table-main/wl-table-main.vue"
export default component.exports